import React from 'react';
import { AvGroup, AvInput } from 'availity-reactstrap-validation';
import { FormattedMessage } from 'react-intl';
import { Label } from 'reactstrap';

const DefaultCourseField = ({ object, ...props }) => {
  return (
    <AvGroup className="form-label-group">
      <FormattedMessage id="defaultCourseLabel">
        {(placeholder) => (
          <AvInput
            type="text"
            name="defaultCourse"
            value={object['defaultCourse']}
            placeholder={placeholder}
            // hint: validate gets the value from valueParser and validates it then
            validate={{ number: true }}
            valueParser={(value) => {
              if (value === '') {
                return undefined; // Return undefined for empty values
              }
              const parsedNumber = parseInt(value);
              return parsedNumber >= 0 && parsedNumber <= 3 ? parsedNumber : {}; // {} is definitely not a number
            }}
            {...props}
          />
        )}
      </FormattedMessage>
      <Label for="course">
        <FormattedMessage id="defaultCourseLabel" />
      </Label>
    </AvGroup>
  );
};

export default DefaultCourseField;
